import { STATUS } from "@/constant/statusConstants";

export const ProductCategoryInitialValues = (localeCodes, showData) => ({
  code: showData?.data?.code || "",
  status: showData?.data?.status || STATUS.INACTIVE,
  localizations: localeCodes.reduce((acc, localeCode) => {
    acc[localeCode] = showData?.data?.localization_contents?.[localeCode] ?? "";
    return acc;
  }, {}),
});
